import { Navigate, Outlet } from "react-router";
import { getCurrentRole } from "../lib/auth";
import { ROLE_LABEL_LO } from "../lib/roles";
import {
  TIER_HOME,
  TIER_LABEL_LO,
  canReach,
  tierOf,
  type Tier,
} from "../lib/tier";

/**
 * กันไม่ให้ผู้ใช้เปิดจอของระดับที่ตัวเองไม่ได้อยู่
 *
 * นี่เป็นแค่การนำทาง **ไม่ใช่กลไกความปลอดภัย** — API บังคับสิทธิ์จริงด้วย
 * `RequireRole` + `domain.Scope` อีกชั้นเสมอ (ADR-0016) เหตุผลที่ต้องมีฝั่งนี้ด้วย
 * คือคนที่สิทธิ์ไม่ถึงควรเจอคำอธิบายเป็นภาษาลาว ไม่ใช่จอที่ยิง 403 รัว ๆ
 */
export function RequireTier({ tier }: { tier: Tier }) {
  const role = getCurrentRole();
  const actual = tierOf(role);
  if (canReach(actual, tier)) return <Outlet />;
  if (actual) return <Navigate to={TIER_HOME[actual]} replace />;
  return (
    <AccessDeniedPage
      required={tier}
      roleLabel={role ? ROLE_LABEL_LO[role] : null}
    />
  );
}

export function AccessDeniedPage({
  required,
  roleLabel,
}: {
  required: Tier;
  roleLabel: string | null;
}) {
  return (
    <div className="access-denied stack">
      <h1 className="page-title">ສິດບໍ່ພຽງພໍ</h1>
      <p className="body-sm">
        ໜ້ານີ້ສຳລັບ <strong>{TIER_LABEL_LO[required]}</strong> ເທົ່ານັ້ນ
      </p>
      <p className="caption">ບັນຊີຂອງທ່ານ: {roleLabel ?? "ບໍ່ຮູ້ຈັກ"}</p>
    </div>
  );
}
